import { createAction } from '@reduxjs/toolkit';
import type { BoundaryTerritoryGroupId } from '../boundaries/boundaryIdentifier.type';
import { type BoundaryTerritoryGroup } from '../boundaryTerritoryGroups/boundaryTerritoryGroups.state';
import {
  BOUNDARY_TERRITORY_DETAILS_FETCH_DETAILS_ERROR,
  BOUNDARY_TERRITORY_DETAILS_FETCH_DETAILS_REQUEST,
  BOUNDARY_TERRITORY_DETAILS_FETCH_DETAILS_SUCCESS,
  BOUNDARY_TERRITORY_DETAILS_UPDATE_MANUAL_ASSIGNMENTS,
} from './boundaryTerritoryDetails.actionTypes';
import { type BoundaryTerritoryGroupDetails } from './boundaryTerritoryDetails.types';

export const boundaryTerritoryGroupsFetchDetailsRequest = (
  boundaryTerritoryGroups: ReadonlyArray<BoundaryTerritoryGroup>
) => ({
  type: BOUNDARY_TERRITORY_DETAILS_FETCH_DETAILS_REQUEST,
  payload: {
    boundaryTerritoryGroups,
  },
}) as const;

export const boundaryTerritoryGroupsFetchDetailsSuccess = (
  results: ReadonlyArray<{
    boundaryTerritoryGroupId: BoundaryTerritoryGroupId;
    details: BoundaryTerritoryGroupDetails;
  }>,
  filterHash: string,
) => ({
  type: BOUNDARY_TERRITORY_DETAILS_FETCH_DETAILS_SUCCESS,
  payload: {
    results,
    filterHash,
  },
}) as const;

export const boundaryTerritoryGroupsFetchDetailsError = (error: Error) => {

  return {
    type: BOUNDARY_TERRITORY_DETAILS_FETCH_DETAILS_ERROR,
    payload: { error },
  } as const;
};

export const boundaryTerritoryDetailsUpdateManualAssignments = (
  boundaryTerritoryGroupId: number, manualAssignments: Readonly<{[boundaryTerritoryId: string]: readonly number[]}>
) => ({
  type: BOUNDARY_TERRITORY_DETAILS_UPDATE_MANUAL_ASSIGNMENTS,
  payload: {
    boundaryTerritoryGroupId,
    manualAssignments,
  },
}) as const;

export const boundaryTerritoryDetailsZoomedLoadingStart = createAction('BOUNDARY_TERRITORY_DETAILS_ZOOMED_LOADING_START');

export const boundaryTerritoryDetailsZoomedLoadingSuccess = createAction('BOUNDARY_TERRITORY_DETAILS_ZOOMED_LOADING_SUCCESS', (
  results: ReadonlyArray<{
    boundaryTerritoryGroupId: BoundaryTerritoryGroupId;
    details: BoundaryTerritoryGroupDetails;
  }>,
  filterHash: string,
) => {
  return { payload: { results, filterHash } };
});

export const boundaryTerritoryDetailsZoomedLoadingError = createAction('BOUNDARY_TERRITORY_DETAILS_ZOOMED_LOADING_ERROR', (error: Error) => {
  return { payload: { error } };
});
